import { graphql } from 'react-relay';

export const drawingSetVersionChangeStatusMutation = graphql`
    mutation drawingSetVersionChangeStatusMutation($input: DrawingSetVersionChangeStatusInput!) {
        drawingSetVersionChangeStatus(input: $input) {
            ...drawingSetVersionFragment
        }
    }
`;
